<template>
  <svg fill="none" height="9" viewBox="0 0 9 9" width="9" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.96485 5.14434H5.73285V8.45634H4.03685V5.14434H0.804852V3.60834H4.03685V0.296343H5.73285V3.60834H8.96485V5.14434Z"
        fill="currentColor"/>
  </svg>
</template>
